import * as React from 'react'
import { useAppSelector } from '../../../../reducers'
import { selectCreditTypes } from '../../../../reducers/credits'

interface CreditTypeOption {
    name: string;
    value: string;
}

export default function useDisplayTypes(): CreditTypeOption[] {
    const creditTypes = useAppSelector(selectCreditTypes)

    return React.useMemo(() => {
        return creditTypes
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((type) => ({
                name: type.name,
                value: type.name,
            }))
    }, [creditTypes])
}
